import { render, staticRenderFns } from "./SupplyRequestView.vue?vue&type=template&id=541ec1cc"
import script from "./SupplyRequestView.vue?vue&type=script&lang=js"
export * from "./SupplyRequestView.vue?vue&type=script&lang=js"
import style0 from "./SupplyRequestView.vue?vue&type=style&index=0&id=541ec1cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports